import type { PropsWithChildren } from "react";

export const NavContainer = ({ children }: PropsWithChildren) => {
    return <div className="sw-layout-subnav">{children}</div>;
};
